import { render, staticRenderFns } from "./devicesDashboardList.vue?vue&type=template&id=a0f88a62&scoped=true"
import script from "./devicesDashboardList.vue?vue&type=script&lang=js"
export * from "./devicesDashboardList.vue?vue&type=script&lang=js"
import style0 from "./devicesDashboardList.vue?vue&type=style&index=0&id=a0f88a62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f88a62",
  null
  
)

export default component.exports